import React, { PureComponent } from 'react';
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import isPropValid from '@emotion/is-prop-valid'
import OnVisible from 'react-on-visible';
import { Grid } from 'style';
import CustomRangeInput from '../common/rangeInput/rangeInput.component';
import Spacer100 from '../common/spacers/spacer100.component';

class TypetesterComponent extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            backgroundColor: this.props.backgroundColor,
            textColor: this.props.textColor,
            initialFontSize: this.props.initialFontSize,
            largestFontSize: this.props.largestFontSize,
            fontname: '',
        };
        this.setFontSizeToMax = this.props.displayAsFullscreen;
        this.maxInitialFontSize = 0;
        this.setColor = this.setColor.bind(this);
        this.onVisible = this.onVisible.bind(this);
        this.setFontSize = this.setFontSize.bind(this);
        this.getMaxInitialFontSize = this.getMaxInitialFontSize.bind(this);
        this.onChangeFontType = this.onChangeFontType.bind(this);
    }
    componentDidMount() {
        if (this.setFontSizeToMax == true) {
            this.maxInitialFontSize = 300;
            this.setFontSize(300);
            setTimeout(this.getMaxInitialFontSize, 500);
        } else {
            if (window.innerWidth < 500) {
                this.setFontSize(30);
            } else {
                this.setFontSize(this.props.initialFontSize);
            }
        }
        if (this.props.font.length) {
            this.setState({
                fontname: `${this.props.id}-${this.props.font[0].weight}`,
            });
        }
        this.setColor(this.getBackgroundColor(0), this.getTextColor(0));
    }
    onChangeFontType(e) {
        this.setState({ fontname: e.target.value });
    }
    setColor(bg, text) {
        this.setState({ backgroundColor: bg, textColor: text });
    }
    getMaxInitialFontSize() {
        if (this.typetester.clientHeight > window.innerHeight) {
            if (this.maxInitialFontSize > 20) {
                this.maxInitialFontSize--;
                this.setFontSize(
                    this.maxInitialFontSize,
                    this.getMaxInitialFontSize
                );
            }
        } else {
            this.setState({
                initialFontSize: this.maxInitialFontSize,
                largestFontSize: this.maxInitialFontSize,
            });
            this.sizeRangeInput.setValue(this.maxInitialFontSize);
        }
    }
    setFontSize(size, callback) {
        this.fontSize = size;
        this.preview.style.fontSize = `${size}px`;
        if (callback) {
            callback();
        }
    }
    getTextColor(i) {
        let { textColorOptions = '' } = this.props;
        if (textColorOptions) {
            textColorOptions = textColorOptions.split(',');
            return textColorOptions[i];
        }
        return this.props.textColor.hex;
    }
    getBackgroundColor(i) {
        let { backgroundColorOptions = '' } = this.props;
        if (backgroundColorOptions) {
            backgroundColorOptions = backgroundColorOptions.split(',');
            return backgroundColorOptions[i];
        }
        return this.props.backgroundColor.hex;
    }
    onVisible() {
        this.setEndOfContenteditable(this.preview);
    }
    setEndOfContenteditable(contentEditableElement) {
        var range, selection;
        if (document.createRange) {
            //Firefox, Chrome, Opera, Safari, IE 9+
            range = document.createRange(); //Create a range (a range is a like the selection but invisible)
            range.selectNodeContents(contentEditableElement); //Select the entire contents of the element with the range
            range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
            selection = window.getSelection(); //get the selection object (allows you to change selection)
            selection.removeAllRanges(); //remove any selections already made
            selection.addRange(range); //make the range you have just created the visible selection
        } else if (document.selection) {
            //IE 8 and lower
            range = document.body.createTextRange(); //Create a range (a range is a like the selection but invisible)
            range.moveToElementText(contentEditableElement); //Select the entire contents of the element with the range
            range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
            range.select(); //Select the range (make it the visible selection
        }
    }
    render() {
        const {
            id,
            fontName,
            font,
            backgroundColorOptions,
            text,
            smallestFontSize,
            downloadFile,
            capitalLettersOnly
        } = this.props;
        const showBackgroundColorOptions =
            backgroundColorOptions &&
            backgroundColorOptions.split(',').length > 1;
        const showFontypeOptions = font && font.length > 1;
        return (
            <Grid.Overflow /*removed innerRef*/ ref={el => (this.typetester = el)}>
                <TypeTesterWrapper
                    id="TypeTester"
                    percent={60}
                    onChange={this.onVisible}
                    backgroundColor={this.state.backgroundColor}
                    textColor={this.state.textColor}
                    setFontSizeToMax={this.setFontSizeToMax}>
                    <Spacer100 />
                    <FontFiles fontfiles={font} fontName={id} />
                    <Grid.InnerContainer>
                        <Grid.Row>
                            <Grid.Col>
                                <TypeTesterMenu>
                                    <TypeTesterMenuItem margin="0 auto 10px 0" mobilemargin="0 auto 10px 0" css={TypeTesterMenuItem_Title}>
                                        {fontName}
                                        {showFontypeOptions && (
                                            <TypeTesterMenuItem margin="0 80px 0 10px">
                                                <FontTypePicker
                                                    fontfiles={font}
                                                    fontName={id}
                                                    onChange={
                                                        this.onChangeFontType
                                                    }
                                                />
                                            </TypeTesterMenuItem>
                                        )}
                                    </TypeTesterMenuItem>
                                    <TypeTesterMenuItem margin="0 auto 10px auto" mobilemargin="0 auto 10px 0">
                                        <TypeTesterMenuItem>
                                            <TypeTesterMenuItem>
                                                <CustomRangeInput
                                                    id="size"
                                                    min={smallestFontSize}
                                                    max={this.state.largestFontSize}
                                                    defaultValue={
                                                        this.state.initialFontSize
                                                    }
                                                    styling={{
                                                        cursor: {
                                                            size: 24,
                                                            backgroundColor: this
                                                                .state
                                                                .backgroundColor,
                                                            borderWidth: 2,
                                                            borderColor: this.state
                                                                .textColor,
                                                        },
                                                        track: {
                                                            height: '30px',
                                                            borderRadius: '2px',
                                                            borderWidth: 1,
                                                            color: this.state
                                                                .textColor,
                                                            borderColor: this.state
                                                                .textColor,
                                                        },
                                                    }}
                                                    ref={el => {
                                                        this.sizeRangeInput = el;
                                                    }}
                                                    onChange={this.setFontSize}
                                                />
                                            </TypeTesterMenuItem>
                                        </TypeTesterMenuItem>
                                    </TypeTesterMenuItem>
                                    {showBackgroundColorOptions && <TypeTesterMenuItem margin="0 0 10px auto">
                                        <TypeTesterMenuItem
                                        >
                                            {showBackgroundColorOptions &&
                                                backgroundColorOptions
                                                    .split(',')
                                                    .map((color, i) => (
                                                        <CustomRadio
                                                            key={`color-${i}`}
                                                            className={this.state.backgroundColor == color ? 'active-radio' : ''}
                                                            borderColor={this.getTextColor(
                                                                i
                                                            )}>
                                                            {/* <input
                                id={`color-${i}`}
                                name="radio"
                                type="radio"

                              /> */}
                                                            <label
                                                                htmlFor={`color-${i}`}
                                                                style={{
                                                                    backgroundColor: color,
                                                                }}
                                                                onClick={this.setColor.bind(
                                                                    this,
                                                                    color,
                                                                    this.getTextColor(
                                                                        i
                                                                    )
                                                                )}
                                                            />
                                                        </CustomRadio>
                                                    ))}
                                        </TypeTesterMenuItem>
                                    </TypeTesterMenuItem>}
                                </TypeTesterMenu>
                                <TypeTesterPreview
                                    suppressContentEditableWarning={true}
                                    contentEditable="true"
                                    spellcheck="false"
                                    /*removed innerRef*/ ref={el => (this.preview = el)}
                                    transition={'font-size 0s'}
                                    fontName={this.state.fontname}
                                    capitalLettersOnly={capitalLettersOnly}>
                                    {text}
                                </TypeTesterPreview>



                                {downloadFile &&
                                    downloadFile.url && (
                                        <div>
                                            <Spacer100 />
                                            <TypeTesterMenuItem margin="0 0 -3px 0">
                                                <h4><a
                                                    href={
                                                        downloadFile.url
                                                    }>
                                                    Download</a></h4>
                                            </TypeTesterMenuItem>
                                        </div>
                                    )}



                            </Grid.Col>
                        </Grid.Row>
                    </Grid.InnerContainer>
                    <Spacer100 />
                </TypeTesterWrapper>
            </Grid.Overflow>
        );
    }
}

const FontTypePicker = ({ fontfiles, fontName, onChange }) => {
    let fontfaces = [];
    fontfiles &&
        fontfiles.map((fontfile, i) => {
            fontfaces.push(
                <option
                    key={`${fontName}-${fontfile.weight.toLowerCase()}-${i}`}
                    value={`${fontName}-${fontfile.weight.toLowerCase()}`}>
                    {fontfile.weight} ↓
        </option>
            );
        });

    return (
        <FontTypePickerSelect>
            <label>
                <select onChange={onChange}>
                    {fontfaces}
                </select>
            </label>
        </FontTypePickerSelect>
    );
};

const FontTypePickerSelect = styled.div`
  position: relative;

  &:after {
    /* content: '>>'; */
    position: absolute;
    top: -31%;
    width: 0;
    height: 0;
    right: 10px;
    bottom: 0;
    margin: auto;
    /* border-style: solid;
    border-width: 5px 5px 0 5px;
    border-color: #fff transparent transparent transparent; */
    pointer-events: none;
    transform: rotate(90deg);
  }

  &:before {
    width: 30px;
    position: absolute;
    top: 1px;
    right: 1px;
    bottom: 1px;
    background: transparent;
    content: '';
    pointer-events: none;
  }

  &:hover {
    &:before {
      background: transparent;
    }
  }

  select {
    border: none;
    box-shadow: none;
    border-radius: 0;
    background: transparent;
    height: 100%;
    width: 100%;
    cursor: pointer;
    outline: none;
    padding-right: 35px;
    border: 1px solid transparent;
    color: inherit;

    /* // Disable default styling on ff */
    -moz-appearance: none;

    /* // Disable ugly ass outline on firefox  */
    &:-moz-focusring {
      color: inherit;
      text-shadow: 0 0 0 #000;
    }

    /* // Disable default styling on webkit browsers  */
    -webkit-appearance: none;

    /* // Disable default arrow on IE 11+ */
    &::-ms-expand {
      display: none;
    }

    &:focus {
      border-color: transparent;
    }
  }
`;

const FontFiles = ({ fontfiles, fontName }) => {
    let fontfaces = [];
    fontfiles &&
        fontfiles.map(fontfile => {
            fontfaces.push(
                `@font-face {font-family: '${fontName}-${fontfile.weight.toLowerCase()}';font-style: normal;font-weight: normal;src: url('${
                fontfile.fontfile.url
                }') format('woff');}`
            );
        });

    return <style>{fontfaces.join('')}</style>;
};

const TypeTesterWrapper = styled(OnVisible, {
    shouldForwardProp: prop =>
        isPropValid(prop) && prop !== 'setFontSizeToMax'
})`
    width: 100%;
    min-height: ${props => (props.setFontSizeToMax ? '100vh' : 'auto')};
    position: relative;
    background-color: ${props => props.backgroundColor};
    color: ${props => props.textColor};
    transition: background-color 0.5s, color 0.5s;
`;
const TypeTesterMenu = styled.div`
    display: flex;
    margin-bottom: 40px;
    flex-wrap: wrap;
`;
const TypeTesterMenuItem = styled.div`
    flex: 0 1 auto;
    align-items: center;
    flex-wrap: wrap;
    display: flex;
    margin: ${props => props.margin};
    min-height: 30px;
    min-width: ${props => props.minWidth ? props.minWidth : 'auto'};
    @media (max-width: 500px) {
      margin: ${props => props.mobilemargin ? props.mobilemargin : props.margin};
    }
`;
const TypeTesterMenuItem_Title = css`

    @media (max-width: 500px) {
      min-width: 100%;
    }
`;
const TypeTesterPreview = styled.div`
    font-size: ${props => props.fontSize || 20}px;
    line-height: 1.2;
    transition: ${props => props.transition};
    font-family: ${props => `${props.fontName}`};
    text-transform: ${props => props.capitalLettersOnly ? 'uppercase' : 'initial'};
    &:focus {
        outline: none;
    }
`;

const CustomRadioSize = 30;
const CustomRadio = styled.div`
    width: ${CustomRadioSize}px;
    height: ${CustomRadioSize}px;
    margin: 3px;
    margin-left: 0px;
    &:first-child {
        margin-left: -3px;
    }
    display: inline-block;
    input[type='radio'] {
        position: absolute;
        right: 10000%;
    }
    label {
        width: ${CustomRadioSize - 10}px;
        height: ${CustomRadioSize - 10}px;
        background-color: #fff;
        border-radius: 20px;
        display: block;
        margin: 5px;
    }
    &.active-radio label{
      &:after {
            content: '';
            position: absolute;
            width: ${CustomRadioSize - 10}px;
            height: ${CustomRadioSize - 10}px;
            border: 2px solid ${props => props.borderColor};
            border-radius: 50%;
            margin: 5px;
            margin: -2px;
        }
    }
`;

export default TypetesterComponent;
